// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-ConfirmSubmitModal-__ConfirmSubmitModal___qG5I4","modal-dialog":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-ConfirmSubmitModal-__ConfirmSubmitModal___eV3OO"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/Transfer/TransferDetail/TransferForm/ConfirmSubmitModal/ConfirmSubmitModal.css
// module id = 2146
// module chunks = 0